import { render, staticRenderFns } from "./StepItem.vue?vue&type=template&id=0591f8c6&scoped=true&"
import script from "./StepItem.vue?vue&type=script&lang=js&"
export * from "./StepItem.vue?vue&type=script&lang=js&"
import style0 from "./StepItem.vue?vue&type=style&index=0&id=0591f8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591f8c6",
  null
  
)

/* custom blocks */
import block0 from "./StepItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports